import React, { useEffect } from "react";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

const Logout = () => {

	const navigate = useNavigate();

	useEffect(() => {
		const logoutUser = async () => {
			try {
				localStorage.clear();
				await signOut();
				navigate("/login");
			} catch (error) {
				console.error("Logout error:", error);
			}
		};

		logoutUser();
	}, [navigate]);

	return (
		<div>Logout</div>
	);
};

export default Logout;